
import { createContext } from 'react'

export const UidContext = createContext();
export const LoaderContext = createContext();

